import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Box, Button, FormControl, Text, Checkbox } from '@chakra-ui/react';
import { Modal, Textarea } from 'shared-components';

import { ApplicationState } from '../../../../store';
import { getDisplayName } from '../../../../utilities/formatting';
import { IMessage } from 'types';
import { useTranslation } from "react-i18next";

export interface IProps {
  fieldId: string;
  optionId: string;
  hideSendToStudent?: boolean;
  onSubmit: (message: IMessage) => void;
  onClose: () => void;
}

const UpdateConflictModal = (props: IProps) => {
    const { t } = useTranslation('dialogs');
  const { fieldId, optionId, hideSendToStudent, onSubmit, onClose } = props;
  const [note, setNote] = useState('');
  const [isSendToStudent, setIsSendToStudent] = useState(false);

  const { auth, config, student } = useSelector(
    ({ auth, config, student }: ApplicationState) => ({ auth, config, student }),
    shallowEqual,
  );

  const userName = auth.student_number!;
  const displayName = getDisplayName(auth, config);

  const submit = () => {
    const author = userName || 'Anonymous';
    const message: IMessage = {
      message: `CAS Checklist Updated${note ? `: ${note}` : ''}`,
      createdAt: Date.now(),
      isSendToStudent,
      messageType: 'note',
      author,
      authorName: displayName || author,
      messageFrom: 'uni',
      messageTo: 'uni',
    };

    onSubmit(message);
    onClose();
  };

  const isCourseRelease = fieldId === 'courses' && optionId === 'release';

  return (
    <Modal
      id="update-conflict"
      show={true}
      title={isCourseRelease ? t('dialogs:releaseStudent') : t('dialogs:keepValue')}
      onClose={onClose}
      footer={
        <Button id="submit-log-button" onClick={submit} variant="solid" size="lg">
          Submit
        </Button>
      }
    >
      {isCourseRelease ? (
        <>
          <Text>{t('dialogs:notePleaseEnsureYouHaveResolvedA')}</Text>
          <Text>{t('dialogs:theStudentWillBeEmailedALinkToRe')}</Text>
        </>
      ) : (
        <Text>
          {t('dialogs:note')}{' '}
          {config?.pathwayIds?.length ? student.config.resolveConflictsModalText : config.resolveConflictsModalText}
        </Text>
      )}

      <FormControl size="lg" mb={6}>
        <Textarea
          id={'message'}
          label={t('dialogs:addNoteOptional')}
          value={note}
          onChange={(event: React.FormEvent<HTMLTextAreaElement>) => setNote(event.currentTarget.value)}
        />
      </FormControl>

      {!hideSendToStudent && (
        <Box>
          <Checkbox isChecked={isSendToStudent} onChange={() => setIsSendToStudent(!isSendToStudent)} size="lg">
            {t('dialogs:sendThisNoteToStudent')}
                                </Checkbox>
        </Box>
      )}
    </Modal>
  );
};

export default UpdateConflictModal;
